import React, { useRef, useEffect } from "react";
import QRCode from 'react-qr-code';
import html2canvas from "html2canvas";  // Import html2canvas
import styles from "./index.module.css";
import Logo from "../../../../../assets/images/brand/login_logo.png";
import Stamp from "../../../../../assets/images/brand/star-stamp.png";
import Seal from "../../../../../assets/images/brand/Seal-removebg-preview.png";

const QR_Link = process.env.REACT_APP_PUBLIC_QR_LINK;

const formatDateWithSuperscript = (dateString) => {
    if (!dateString) return '';

    const parts = dateString.split(' ');

    if (parts.length < 3) return dateString;

    let day = parts[0].match(/\d+/)[0];
    const suffix = parts[0].replace(/\d+/, '');
    const month = parts[1];
    const year = parts[2];

    day = day.padStart(2, '0');

    return { day, suffix, month, year };
};

const IBSUOfficialCertificateImage = ({ data, onImageGenerated }) => {
    const certificateRef = useRef(null);
    const formattedDate = formatDateWithSuperscript(data?.completion_date);
    const formattedCertificateDate = formatDateWithSuperscript(data?.issued_date);
    useEffect(() => {
        const generateImage = async () => {
            if (!certificateRef.current) return;

            const canvas = await html2canvas(certificateRef.current, {
                scale: window.devicePixelRatio, // Capture at higher resolution
                useCORS: true, // Prevent cross-origin issues
                logging: false,
            });

            const imgData = canvas.toDataURL("image/jpeg", 1.0);

            // Send the generated image to the parent component
            if (onImageGenerated) {
                onImageGenerated(imgData);
            }
        };

        setTimeout(generateImage, 500); // Delay to ensure the component is fully rendered
    }, []);

    return (
        // <div className={`main-card`}>
        <div ref={certificateRef} className={styles.certificateContainer} style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
            <img src={data?.certificate_template?.header_logo} alt="Logo" className={styles.logo} crossOrigin="anonymous" />
            <p className={styles.text}>{data?.certificate_template_version?.certificate_phrase_1}</p>
            <p className={styles.studentName}>{data?.student_name}</p>
            <p className={styles.textSentence}>
                {data?.certificate_template_version?.certificate_phrase_2}
            </p>
            <p className={styles.textSentence}>
                {data?.certificate_template_version?.certificate_phrase_3}
            </p>
            <h3 className={styles.courseName}>{data?.course_batch?.course.name}</h3>
            <p className={styles.textSentence}>{data?.certificate_template_version?.conducted_by_phrase}</p>
            <p className={styles.textSentence}>{data?.certificate_template_version?.completion_phrase} {formattedCertificateDate.day}<span className={styles.superScript}>{formattedCertificateDate.suffix}</span> {formattedCertificateDate.month} {formattedCertificateDate.year}</p>
            {/* <p className={styles.textSentence}>{data?.issued_date}</p> */}
            {/* Footer with Signatures, Stamp, and QR */}
            <div className={styles.footer}>
                <div className={styles.sealContainer}>
                    <img src={Seal} alt="Seal" className={styles.sealImg} />
                    <p className={styles.signature}>{data?.certificate_template_version?.signature_designation_1}</p>
                    <p className={styles.signatureBottom}>{data?.certificate_template_version?.signature_designation_2}</p>
                </div>
                <img src={data?.certificate_template?.footor_logo} alt="Stamp" className={styles.stamp} crossOrigin="anonymous" />
                <div style={{ textAlign: "center" }}>
                    <QRCode
                        value={`${QR_Link}/document_ref/${data?.document_ref}`}
                        size={70}
                        className="code"
                    />
                    <p className={styles.qrText}>Scan to verify certificate.</p>
                    <p className={styles.detailsText}>Document Ref.: {data?.document_ref}</p>
                    <p className={styles.detailsText}>Completion Date: {formattedDate.day} {formattedDate.month} {formattedDate.year}</p>
                </div>
            </div>
        </div>
        // </div>
    );
};

export default IBSUOfficialCertificateImage;